import { motion } from "framer-motion";
import { Badge } from "@/components/ui/badge";

const PricingHero = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="py-20 px-4 text-center bg-gradient-to-b from-background to-secondary/20">
      <motion.div 
        className="container mx-auto max-w-4xl"
        variants={containerVariants}
        initial="hidden"
        animate="visible"
      >
        <motion.h1
          className="text-4xl md:text-6xl font-bold mb-4"
          variants={itemVariants}
        >
          Pick your tier. Skip the agency.
        </motion.h1>

        <motion.p
          className="text-xl text-muted-foreground mb-6"
          variants={itemVariants}
        >
          Three tiers. 7-day free trial on all of them. Monthly billing —
          cancel any time from your dashboard.
        </motion.p>

        <motion.div
          className="flex flex-wrap justify-center gap-2"
          variants={itemVariants}
        >
          <Badge className="bg-primary/10 text-primary border-0 text-sm py-1">
            7-day free trial
          </Badge>
          <Badge className="bg-primary/10 text-primary border-0 text-sm py-1">
            Save ~17% on annual
          </Badge>
          <Badge className="bg-primary/10 text-primary border-0 text-sm py-1">
            Cancel anytime
          </Badge>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default PricingHero;